module.exports = __webpack_public_path__ + "static/media/newpaltzlogo.f8e7f6d7.jpeg";